var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("article", [
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("section", [
          _c(
            "div",
            { staticClass: "form_submit", on: { click: _vm.onOrder } },
            [_c("button", { attrs: { type: "button" } }, [_vm._v("注文する")])]
          )
        ])
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("div", [_vm._v("カート")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "product" }, [
      _c("div", [_vm._v("画像")]),
      _vm._v(" "),
      _c("div", { staticClass: "product_content" }, [
        _c("div", [
          _c("div", [_vm._v("注文ID")]),
          _vm._v(" "),
          _c("div", [_vm._v("SO10000000000")])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", [_vm._v("注文期限")]),
          _vm._v(" "),
          _c("div", [_vm._v("2023/10/23")])
        ]),
        _vm._v(" "),
        _c("div", [_vm._v("¥100,000")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "total_price" }, [
      _c("div", [_vm._v("合計金額:")]),
      _vm._v(" "),
      _c("div", [_vm._v("¥100,000")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7583df74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7583df74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/pages/Cart.vue
// module id = null
// module chunks = 